export const SET_BREADCRUMB_ITEMS = "SET_BREADCRUMB_ITEMS";
export const SET_MIMO_LOADER = "SET_MIMO_LOADER";
